import FAQSection from "@components/FAQSection";
import { faqData } from "./data";
export const  Faq = ()=>{
    return(
        <section className="container">

        <FAQSection faqData={faqData} heading='Frequently Asked Questions '   setStyle={true}/> 
        </section>
    )
} 